export const PRODUCT_TAB_FULL_ROUTE = 'view-product/:id/:cbTabRouteId/:cbTabRouteId2/:cbTabRouteId3';
